module.exports = __webpack_public_path__ + "static/media/021-storm.e8fe47cc.svg";